import { REQUIRED } from '@atlassian/jira-issue-create-common-types/src/common/constants/index.tsx';
import type { Option as FieldValue } from '@atlassian/jira-issue-field-project/src/common/types.tsx';
import type { JiraProjectFieldInput, ProjectDefaultValueType } from './types.tsx';

export const mutateProjectField = (
	selectedProject: FieldValue,
	fieldId: string,
): JiraProjectFieldInput => ({
	projectFields: [
		{
			fieldId,
			project: {
				projectId: selectedProject.projectId || '',
			},
		},
	],
});

export const validateProjectField = (
	data?: FieldValue,
	// @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
	isRequired: boolean,
): string | undefined => {
	if (isRequired) {
		if (!data) {
			return REQUIRED;
		}
	}
	return undefined;
};

export const transformDefaultProjectValue = (data: ProjectDefaultValueType): FieldValue => ({
	label: data.name,
	value: data.key,
	iconUrl: data.avatar.large,
	projectId: data.id,
});
